import React, { Fragment, useEffect, useState } from 'react';
import _uniqueId from 'lodash/uniqueId';
import BiHelp from './BiHelp';

const BiComboBox = ({
    item,
    items,
    onItemSelected,
    name,
    disabled,
    placeholder,
    width,
    height,
    help,
    helpKey,
    helpMainKey,

    customItems,
    groupName,
}) => {
    let cbStyle = {
        height: height == null ? "" : ((height) + "px")
    }
    let dod = {
        width: width == null ? "" : ((width) + "px")
    }
    if (width != null && width.indexOf("%") > -1) {
        dod.width = width;
    }
    const [opt, setOpt] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {

        if (item != null) {
            setOpt(item.id != null ? item : { id: -1 });
        }
    }, [item]);

    useEffect(() => {
        if (loaded == false) {
            setLoaded(true);
        }

    }, [])

    const onSelectionChanged = (e) => {
        const { value } = e.target;

        setOpt({ id: value });
        let its = items.filter(item => item.id == value);

        if (its.length > 0) {
            var keyValue = its[0].naziv;
            onItemSelected({ target: { name: name, value: { id: parseInt(value), naziv: keyValue } } });
        }
        else if(value=="-99"){
            onItemSelected({ target: { name: name, value: { id: -99, naziv: null } } });
        }
        else {
            onItemSelected({ target: { name: name, value: { id: null, naziv: null } } });
        }
    }

    if (customItems != null) {
        return (
            <Fragment>
                {items &&
                    <div className="biHelpCont" style={dod}>
                        <select style={cbStyle} disabled={disabled ? "disabled" : ""} className="form-select form-select-sm biControlInline" placeholder="Iskanje" onChange={onSelectionChanged} value={opt.id}>
                            <optgroup label="Sistem">
                                <option value="-1">{placeholder == null ? "---" : placeholder}</option>
                                {
                                    customItems
                                }
                            </optgroup>
                            <optgroup label={groupName}>
                                {
                                    items.map(d => <option key={_uniqueId("bic-")} value={d.id}>{d.naziv}</option>)
                                }
                            </optgroup>
                        </select>

                        {(help == true) &&
                            <BiHelp helpKey={helpKey ? helpKey : name} helpMainKey={helpMainKey ? helpMainKey : null}></BiHelp>
                        }
                    </div>

                }
            </Fragment>
        );
    }
    else {
        return (
            <Fragment>
                {items &&


                    <div className="biHelpCont" style={dod}>
                        <select style={cbStyle} disabled={disabled ? "disabled" : ""} className="form-select form-select-sm biControlInline" placeholder="Iskanje" onChange={onSelectionChanged} value={opt.id}>

                            <option value="-1">{placeholder == null ? "---" : placeholder}</option>

                            {
                                items.map(d => <option key={_uniqueId("bic-")} value={d.id}>{d.naziv}</option>)
                            }
                        </select>

                        {(help == true) &&
                            <BiHelp helpKey={helpKey ? helpKey : name} helpMainKey={helpMainKey ? helpMainKey : null}></BiHelp>
                        }
                    </div>

                }
            </Fragment>
        );
    }
}

export default BiComboBox;